<template>
    <div class="FPage">
        <!--        :hide-on-single-page="showPage"-->
        <el-pagination
                @current-change="getPageIndex"
                :current-page.sync="pageNum"
                @size-change="getPageSize"
                :page-size="pageSize"
                :page-sizes="pageSizeData"
                layout="sizes,prev, pager, next,jumper"
                background :total="total">
        </el-pagination>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/8 3:13 下午
     */
    export default {
        name: 'FPage',
        components: {},
        props: {
            pageSize: {
                type: Number,
                default: 10
            },
            total: {
                type: Number,
                default: 100
            },
            showPage: {
                type: Boolean,
                default: true
            },
            pageSizeData: {
                type: Object / Array,
                default: () => [5, 10, 20, 50]
            },
        },
        data() {
            return {
                pageNum: 1
            }
        },
        methods: {
            getPageIndex(num) {
                this.$emit("page", num, this.pageSize);
            },
            getPageSize(size) {
                this.$emit("page", this.pageNum, size);
            }
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .FPage {
        display: inline-block;
        padding: 5px 0;
        width: 100%;
        text-align: center;

        //分页
        .el-pagination {

            .btn-prev:hover {
                background-color: @pageHover;
            }


            .btn-next:hover {
                background-color: @pageHover;
            }
        }

        .el-pagination__jump {
            margin-right: 20px;
            margin-left: 10px;
        }
    }
</style>